import { hasText } from 'utils/helpers';
import ActionButton from './action-button';
import './action-input.less';
import {useMessages} from "../language/language";
import { ChangeEvent, PropsWithChildren, useEffect, useState } from 'react';

export type ActionInputSize = "small"|"big"

type Props = {
  label: string
  actionButtonText: string
  inputText: string
  errorText: string|null
  loginUrl: string|null
  immediateLogin: boolean
  numbersOnly?: boolean
  inputSize: ActionInputSize
  isEnabled: boolean
  onInputTextChanged(newText: string): void
  onActionClicked(): void
}

function cancelNonNumbers(e: ChangeEvent<HTMLInputElement>, f: (newText: string) => void) {
  const txt = e.currentTarget.value;
  if (/^\d*$/.test(txt) && txt.length <= 5) {
    f(txt);
  } else {
    e.preventDefault();
  }
}

export default function ActionInput(props: PropsWithChildren<Props>) {
  const { label, actionButtonText, inputText, numbersOnly, 
    onInputTextChanged, onActionClicked, inputSize, errorText,
    loginUrl, immediateLogin,
    isEnabled
  } = props;
  
  const msg = useMessages();
  
  const [secondsRemaining, setSecondsRemaining] = useState(10);
  
  useEffect(() => {
    if (!immediateLogin) {
      if (hasText(loginUrl)) location.assign(loginUrl!)
      return
    }
    if (!hasText(loginUrl)) return

    const timer = setInterval(() => {
      setSecondsRemaining(prev => {
        if (prev <= 0) {
          clearInterval(timer)
          location.assign(loginUrl!)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [loginUrl, immediateLogin])
  
  return (
    <div className="action-input-container">
      <div className="action-input">
        <label className="label" htmlFor="action-input">
            {label}
        </label>
        <div className="input-outer">
          <div className="input-inner">
            <input 
              id="action-input"
              className={inputSize}
              value={inputText} 
              disabled={!isEnabled}
              onChange={e => onInputTextChanged(e.currentTarget.value)}
              onKeyDown={e => {
                if (e.key === "Enter") {
                  onInputTextChanged(e.currentTarget.value)
                  onActionClicked()
                }
              }}
              autoFocus
            />
          </div>
        </div>
      </div>
      {hasText(loginUrl)
        ? <div
          className="info"
          dangerouslySetInnerHTML={{__html: msg.gameRequiresLogin({ loginUrl: loginUrl!, secondsRemaining })  }}
        />
        : hasText(errorText) &&
        <div className="error">
          {errorText}
        </div> 
      }

      {!hasText(loginUrl) &&
        <ActionButton onClick={onActionClicked}>{actionButtonText}</ActionButton>
      }
    </div>
  )
}
